import React from "react";
import { CCol, CFormGroup, CInput, CLabel, CRow, CSelect } from "@coreui/react";
import { useRemissionNoteFormContext } from "../context/RemissionNoteFormContext";
import {
  REMISSION_NOTE_REASON_CHOICES,
  REMISSION_NOTE_RESPONSIBLE_CHOICES,
} from "../../../models/remission-note";
import { FieldErrors } from "../../form/FieldErrors";
import { getFieldErrors } from "../../../models/errors";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const FormLabel: React.FC<{ required?: boolean; children: React.ReactNode }> = ({ required, children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

export const RemissionNoteFormDetailsSection: React.FC = () => {
  const {
    remissionNoteRef,
    errors,
    onReasonChange,
    onResponsibleChange,
    onEstimatedKilometersChange,
  } = useRemissionNoteFormContext();

  return (
    <>
      <SectionDivider icon="fa-exchange" label="Detalles de la Remisión" />
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>Motivo:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CSelect
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.reasonCode
                  : undefined
              }
              onChange={onReasonChange}
            >
              <option value={""}>-----</option>
              {Array.from(REMISSION_NOTE_REASON_CHOICES.entries()).map(
                (entry) => {
                  return (
                    <option key={entry[0]} value={entry[0]}>
                      {entry[1]}
                    </option>
                  );
                }
              )}
            </CSelect>
            <FieldErrors
              errors={getFieldErrors("reasonCode", errors) as string[]}
            ></FieldErrors>
          </CCol>
          <CCol md={2}>
            <FormLabel required>Responsable:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CSelect
              type="text"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.responsibleCode
                  : undefined
              }
              onChange={onResponsibleChange}
            >
              <option value={""}>-----</option>
              {Array.from(REMISSION_NOTE_RESPONSIBLE_CHOICES.entries()).map(
                (entry) => {
                  return (
                    <option key={entry[0]} value={entry[0]}>
                      {entry[1]}
                    </option>
                  );
                }
              )}
            </CSelect>
            <FieldErrors
              errors={getFieldErrors("responsibleCode", errors) as string[]}
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel required>KMs estimados:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CInput
              type="number"
              defaultValue={
                remissionNoteRef.current
                  ? remissionNoteRef.current.estimatedKilometers
                  : undefined
              }
              onChange={onEstimatedKilometersChange}
              placeholder="KMs estimados"
            ></CInput>
            <FieldErrors
              errors={getFieldErrors("estimatedKilometers", errors) as string[]}
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
    </>
  );
};
